<template>
  <div v-if="type && symbol">
    <div v-if="['icon'].includes(type)">
      <div
        class="d-flex justify-center align-center"
        :style="{
          width: size + 'px',
          height: size + 'px',
          border: outlined_box ? '1px solid #000000' : 'none',
        }"
      >
        <v-icon dark :color="color || ''" :size="size">{{ symbol }}</v-icon>
      </div>
    </div>
    <div v-if="['image'].includes(type)">
      <div v-if="symbol" style="position: relative">
        <v-btn
          v-if="!is_display && !image_file"
          dark
          color="primary"
          small
          icon
          style="position: absolute; top: -24px; z-index: 1"
          :style="{
            left: size - 4 + 'px',
          }"
          @click="handleClearSymbol"
        >
          <v-icon dark> mdi-close </v-icon>
        </v-btn>
        <v-img
          :src="symbol"
          cover
          :style="{
            'max-width': size + 'px',
            height: size + 'px',
            border: outlined_box ? '1px solid #000000' : 'none',
            'background-color': is_image_background_color
              ? '#fafafa'
              : 'transparent',
          }"
        >
        </v-img>
      </div>
    </div>
    <div v-if="['text'].includes(type)">
      <div
        class="d-flex justify-center align-center"
        :style="{
          width: size + 'px',
          height: size + 'px',
          color: color,
          border: outlined_box ? '1px solid #000000' : 'none',
        }"
      >
        <svg
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid meet"
          style="width: 90%; height: 90%"
        >
          <text
            x="50%"
            y="50%"
            text-anchor="middle"
            dominant-baseline="central"
            :font-size="dynamicFontSize"
            fill="currentColor"
            lengthAdjust="spacingAndGlyphs"
            :textLength="dynamicTextLength"
          >
            {{ symbol }}
          </text>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: { default: "" },
    symbol: { default: "" },
    color: { default: "" },
    image_file: { default: null },
    is_image_background_color: { default: false },
    is_display: { default: false },
    outlined_box: { default: true },
    size: { default: 40 },
  },
  emits: ["onClearSymbol"],
  components: {},
  data() {
    return {};
  },
  async created() {},
  methods: {
    handleClearSymbol() {
      // this.symbol = null
      this.$emit("onClearSymbol");
    },
  },
  computed: {
    dynamicFontSize() {
      const len = this.symbol ? this.symbol.length : 0;
      if (len <= 1) return 90; // ตัวเดียว
      if (len === 2) return 60; // 2 ตัวอักษร
      if (len === 3) return 50; // 3 ตัวอักษร
      return Math.max(30, 100 / len);
    },
    dynamicTextLength() {
      const len = this.symbol ? this.symbol.length : 0;
      if (len <= 1) return 90; // ตัวเดียว
      if (len === 2) return 75; // 2 ตัวอักษร
      if (len === 3) return 80; // 3 ตัวอักษร
      return 90;
    },
  },
};
</script>

<style>
</style>

<style scoped>
</style>
